import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import RouteKey from './key';
import NotificationAcknowledgement from '../pages/notificationAcknowledgement/NotificationAcknowledgement';
import DefaultHeaderEmpty from '../components/DefaultHeaderEmpty';

const { error: errorRoute } = RouteKey.child;
const { root: notificationAcknowledgement } = RouteKey['notification-acknowledgement'].child;

const NotificationAcknowledgementRoute = () => (
  <Switch>
    <Route path={`/${notificationAcknowledgement.route}/:uuid`} exact>
      <DefaultHeaderEmpty />
      <NotificationAcknowledgement />
    </Route>
    <Route path="*" exact>
      <Redirect to={`/${errorRoute}`} />
    </Route>
  </Switch>
);
export default NotificationAcknowledgementRoute;
